import {
    SET_INTERVIEWS,
    SET_CURRENT_FORM,
    SET_FORMS_FILTERS,
    SET_INTERVIEWS_TO_MANAGE,
    SET_FORM_SECTIONS,
    SET_CURRENT_SECTION,
    SET_FORM_SURVEYS,
    SET_EMPLOYEES_TO_MANAGE,
    SET_CURRENT_INTERVIEW,
    SET_PERIODS,
    SET_MANAGERS,
    SET_EMPLOYEES_OF_COMPANY,
    SET_INTERVIEWS_FOR_HR,
    SET_HR_TAB_ID,
    SET_DEPARTMENTS_OF_COMPANY,
    SET_NB_WAITING_INTERVIEWS,
    SET_COMPANIES_WITH_EVALUATIONS,
} from "./humanResourcesConstants";
import { setValue, updateIn } from "../../lib/immutable_wrapper";
import moment from "moment";
import { ALL_SELECT_OPTION } from "../../constants";
moment.locale("fr");

export function getDefaultFormsFilters() {
    return {
        period: ALL_SELECT_OPTION,
        inProgressOnly: true,
        displayAllDetails: false,
        level: 1,
        employee: ALL_SELECT_OPTION,
        survey: ALL_SELECT_OPTION,
        manager: ALL_SELECT_OPTION,
        companies: [ALL_SELECT_OPTION],
        departments: [],
    };
}

const initialState = {
    myInterviews: [],
    interviewsToManage: [],
    interviewsForHR: [],
    formsFilters: {
        FORMS_TO_MANAGE: getDefaultFormsFilters(),
        HUMAN_RESOURCES: getDefaultFormsFilters(),
        MY_FORMS: getDefaultFormsFilters(),
    },
    formSurveys: {},
    employeesToManage: [],
    employeesOfCompany: [],
    departmentsOfCompany: [],
    periods: {},
    managers: {},
    tabId: 0,
    nbWaitingInterviews: 0,
};

const formInitialState = {
    currentForm: null,
    currentInterview: null,
    formSections: [],
    currentSectionId: null,
};

export function forms(state = initialState, action) {
    switch (action.type) {
        case SET_INTERVIEWS:
            return setValue(state, ["myInterviews"], action.interviews);
        case SET_INTERVIEWS_TO_MANAGE:
            return setValue(state, ["interviewsToManage"], action.interviews);
        case SET_INTERVIEWS_FOR_HR:
            return setValue(state, ["interviewsForHR"], action.interviewsForHR);
        case SET_FORMS_FILTERS:
            return updateIn(state, ["formsFilters", action.filtersInstance], () => action.filters);
        case SET_FORM_SURVEYS:
            return updateIn(state, ["formSurveys", action.filtersInstance], () => action.formSurveys);
        case SET_PERIODS:
            return updateIn(state, ["periods", action.filtersInstance], () => action.periods);
        case SET_EMPLOYEES_TO_MANAGE:
            return setValue(state, ["employeesToManage"], action.employeesToManage);
        case SET_EMPLOYEES_OF_COMPANY:
            return setValue(state, ["employeesOfCompany"], action.employeesOfCompany);
        case SET_DEPARTMENTS_OF_COMPANY:
            return setValue(state, ["departmentsOfCompany"], action.departmentsOfCompany);
        case SET_MANAGERS:
            return updateIn(state, ["managers", action.filtersInstance], () => action.managers);
        case SET_HR_TAB_ID:
            return setValue(state, ["tabId"], action.tabId);
        case SET_NB_WAITING_INTERVIEWS:
            return setValue(state, ["nbWaitingInterviews"], action.nbWaitingInterviews);
        case SET_COMPANIES_WITH_EVALUATIONS:
            return setValue(state, ["companiesWithEvaluations"], action.companiesWithEvaluations);
        default:
            return state;
    }
}

export function form(state = formInitialState, action) {
    switch (action.type) {
        case SET_CURRENT_FORM:
            return setValue(state, ["currentForm"], action.currentForm);
        case SET_FORM_SECTIONS:
            return setValue(state, ["formSections"], action.formSections);
        case SET_CURRENT_SECTION:
            return setValue(state, ["currentSectionId"], action.currentSectionId);
        case SET_CURRENT_INTERVIEW:
            return setValue(state, ["currentInterview"], action.interview);
        default:
            return state;
    }
}
